(function () {
	const addClasses = (slider) => {
		const sliderWrapper = slider.querySelector(".multicolumn-list__wrapper");
		const slides = slider.querySelectorAll(".multicolumn-list__item");

		slider.classList.add("swiper");
		if (sliderWrapper) sliderWrapper.classList.add("swiper-wrapper");
		if (slides.length > 1) {
			slides.forEach((slide) => {
				slide.classList.add("swiper-slide");
			});
		}
	};

	const removeClasses = (slider) => {
		const sliderWrapper = slider.querySelector(".multicolumn-list__wrapper");
		const slides = slider.querySelectorAll(".multicolumn-list__item");

		slider.classList.remove("swiper");
		if (sliderWrapper) sliderWrapper.classList.remove("swiper-wrapper");
		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initSlider = (section) => {
		const slider = section.querySelector(".swiper--multicolumn");

		if (slider) {
			addClasses(slider);
			/* 869er6qdh — EINMAL bauen, nicht bei jeder Groessenaenderung neu.
			 * initSection() unten haengt initSlider an einen ResizeObserver auf
			 * der SEKTION. Der feuert nicht nur beim Drehen, sondern auch, wenn
			 * ein spaet geladenes Bild die Sektionshoehe aendert. Ohne Wache
			 * stand danach eine ZWEITE Swiper-Instanz auf demselben Container
			 * (gemessen am 28.08., 390 px: 2 Instanzen auf `.swiper--multicolumn`).
			 * Folge: `el.swiper` — der Griff, den jeder Aussenstehende benutzt
			 * (auch mypka-slider-tastatur.js) — zeigte auf die zweite, die nie
			 * etwas mitbekam. Klick bewegte Instanz A, die Pfeiltaste Instanz B,
			 * und der Slider sprang RUECKWAERTS: nach Klick auf Punkt 3
			 * (x = [-696,-338,20,378]) landete Pfeil rechts wieder auf Slide 2
			 * (x = [-338,20,378,736]).
			 * Die Wache ist die des Themes, nicht eine neue: card-slider.js
			 * prueft in Zeile 6 genauso auf `slider-initialized` und setzt die
			 * Klasse in Zeile 78 — und card-slider ist genau der Slider, der
			 * im Test sauber lief (1 Instanz).
			 * addClasses() steht ABSICHTLICH vor der Wache: destroySlider()
			 * nimmt die Swiper-Klassen ab 990 px wieder weg, ohne die Instanz
			 * abzuraeumen. Kommt der Nutzer zurueck ins Schmale, muessen die
			 * Klassen zurueck — die bestehende Instanz uebernimmt dann wieder,
			 * statt dass eine dritte gebaut wird. */
			if (slider.classList.contains("slider-initialized")) return;

			new Swiper(slider, {
				loop: false,
				speed: 800,
				mousewheel: {
					forceToAxis: true,
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
						slidesPerGroup: 1,
						spaceBetween: 8,
					},
					540: {
						slidesPerView: 2,
						slidesPerGroup: 1,
						spaceBetween: 8,
					},
					750: {
						slidesPerView: 3,
						slidesPerGroup: 1,
						spaceBetween: 16,
					},
				},
				pagination: {
					el: slider.querySelector(".multicolumn__pagination"),
					clickable: true,
					type: "custom",
					renderCustom: function (swiper, current, total) {
						let out = "";
						for (let i = 1; i < total + 1; i++) {
							if (i == current) {
								out = `${out}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
							} else {
								out = `${out}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
							}
						}
						return out;
					},
				},
			});

			slider.classList.add("slider-initialized");
		}
	};

	const destroySlider = (section) => {
		const slider = section.querySelector(".swiper--multicolumn");

		if (slider) {
			removeClasses(slider);
		}
	};

	const initSection = (section) => {
		if (section && section.classList.contains("multicolumn-section")) {
			const sectionResizeObserver = new ResizeObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.contentRect.width < 990) {
						initSlider(entry.target);
					} else {
						destroySlider(entry.target);
					}
				});
			});

			sectionResizeObserver.observe(section);
		}
	};

	initSection(document.currentScript.parentElement);

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();
